import { readonly, ref } from "@nuxtjs/composition-api";
import { getProductStockCommand } from "~/modules/catalog/product/composables/useProductStock/commands/getProductStockCommand";
import { getProductListStockCommand } from "~/modules/catalog/product/composables/useProductStock/commands/getProductListStockCommand";
import type { UseProductStockErrors, UseProductStockInterface } from "./useProductStock";

export function useProductStock(): UseProductStockInterface {
  const loading = ref(false);
  const error = ref<UseProductStockErrors>({
    getProductStock: null,
    getProductListStock: null,
  });

  const getProductStock = async (sku: string): Promise<any | null> => {
    let productStock = null;

    try {
      loading.value = true;
      productStock = await getProductStockCommand(sku);
      error.value.getProductStock = null;
    } catch (err) {
      error.value.getProductStock = err;
    } finally {
      loading.value = false;
    }

    return productStock;
  };

  const getProductListStock = async (skus): Promise<any | null> => {
    let productListStock = null;

    try {
      loading.value = true;
      productListStock = await getProductListStockCommand(skus);
      error.value.getProductListStock = null;
    } catch (err) {
      error.value.getProductListStock = err;
    } finally {
      loading.value = false;
    }

    return productListStock;
  };

  return {
    getProductStock,
    getProductListStock,
    error: readonly(error),
    loading: readonly(loading),
  };
}

export * from "./useProductStock";
export default useProductStock;
